import React, {useState} from "react";
import { useFormikContext } from "formik";
import amex from "../../../../../../../images/v2/amex24x24.svg";
import discover from "../../../../../../../images/v2/discover24x24.svg";
import mastercard from "../../../../../../../images/v2/master24x24.svg";
import visa from "../../../../../../../images/v2/visa24x24.svg";
import TextInput from "../../../../../components/form/text-input";
import Switch from "../../../../../components/form/switch";
import useUserStore from "../../../../../stores/user";
import useOrganizationStore from "../../../../../stores/organization";
import PinBasedDebit from "../components/pin-based-debit";
import { getSoftLimitWarning } from "../../../utils/soft-limit";
import styles from "./style.module.scss";

const FlatRate = () => {
  const { values, errors, touched, handleBlur, handleChange, setFieldValue } =
    useFormikContext();

  const user = useUserStore((state) => state.user);
  const pricingDefaults = useOrganizationStore(
    (state) => state.pricingDefaults,
  );
  const nonEditableTemplateOrPricingRestricted =
    values.nonEditableTemplateApplied ||
    user?.organization?.pricing_restricted === 1;

  const [backup, setBackup] = useState({
    flat_rate_amex: values?.flat_rate_amex,
    flat_rate_amex_transaction: values?.flat_rate_amex_transaction
  });


  return (
    <>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h6>Rate fees</h6>
            <div className={styles.accepts}>
              <img src={visa} />
              <img src={mastercard} />
              <img src={discover} />
            </div>
          </div>

          <div className={styles.body}>
            <TextInput
              label={"Flat rate"}
              placeholder={"0.00"}
              suffix={"%"}
              type="text"
              inputMode="decimal"
              id={"flat_rate"}
              name={"flat_rate"}
              value={values.flat_rate}
              onBlur={handleBlur}
              touched={touched?.flat_rate}
              errored={errors?.flat_rate}
              error={errors?.flat_rate}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.flat_rate?.flat_rate?.soft_limit,
                values.flat_rate,
                errors.flat_rate,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "flat_rate",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted}
            />
            <TextInput
              label={"Txn rate"}
              placeholder={"0.00"}
              prefix={"$"}
              type="text"
              inputMode="decimal"
              id={"flat_rate_transaction"}
              name={"flat_rate_transaction"}
              value={values.flat_rate_transaction}
              onBlur={handleBlur}
              touched={touched?.flat_rate_transaction}
              errored={errors?.flat_rate_transaction}
              error={errors?.flat_rate_transaction}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.flat_rate?.flat_rate_transaction?.soft_limit,
                values.flat_rate_transaction,
                errors.flat_rate_transaction,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "flat_rate_transaction",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted}
            />
          </div>
        </div>
      </div>
      <div className={`${styles.container} ${styles.marginTop15}`}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h6>Rate fees amex</h6>
            <div className={styles.accepts}>
              <img src={amex} />
            </div>
          </div>
          <Switch
            id={'flat_rate_amex_toggle'}
            name={'flat_rate_amex_toggle'}
            label="Rate fees amex"
            checked={values?.flat_rate_amex_toggle === "yes"}
            onChange={(e) => {
              handleChange(e);
              setFieldValue('flat_rate_amex_toggle', e.target.checked ? "yes" : "no");
              if(!e.target.checked ){ 
                setFieldValue("flat_rate_amex", 0);
                setFieldValue("flat_rate_amex_transaction", 0);
              }else {
                setFieldValue("flat_rate_amex", backup.flat_rate_amex);
                setFieldValue("flat_rate_amex_transaction", backup.flat_rate_amex_transaction);
              }
            }}
            onBlur={(e) => {
              handleBlur(e);
              setFieldValue('flat_rate_amex_toggle', e.target.checked ? "yes" : "no");
              if(!e.target.checked ){ 
                setFieldValue("flat_rate_amex", 0);
                setFieldValue("flat_rate_amex_transaction", 0);
              }else {
                setFieldValue("flat_rate_amex", backup.flat_rate_amex);
                setFieldValue("flat_rate_amex_transaction", backup.flat_rate_amex_transaction);
              }
            }}
            disabled={nonEditableTemplateOrPricingRestricted}
          />

          <div className={styles.body}>
            <TextInput
              label={"Flat rate"}
              placeholder={"0.00"}
              suffix={"%"}
              type="text"
              inputMode="decimal"
              id={"flat_rate_amex"}
              name={"flat_rate_amex"}
              value={values.flat_rate_amex}
              onBlur={handleBlur}
              touched={touched?.flat_rate_amex}
              errored={errors?.flat_rate_amex}
              error={errors?.flat_rate_amex}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.flat_rate?.flat_rate_amex?.soft_limit,
                values.flat_rate_amex,
                errors.flat_rate_amex,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "flat_rate_amex",
                      value: e.target.rawValue,
                    },
                  });
                  setBackup(prev => ({
                    ...prev,
                    flat_rate_amex: e.target.rawValue,
                  }));
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted || values?.flat_rate_amex_toggle === 'no'}
            />
            <TextInput
              label={"Txn rate"}
              placeholder={"0.00"}
              prefix={"$"}
              type="text"
              inputMode="decimal"
              id={"flat_rate_amex_transaction"}
              name={"flat_rate_amex_transaction"}
              value={values.flat_rate_amex_transaction}
              onBlur={handleBlur}
              touched={touched?.flat_rate_amex_transaction}
              errored={errors?.flat_rate_amex_transaction}
              error={errors?.flat_rate_amex_transaction}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.flat_rate?.flat_rate_amex_transaction
                  ?.soft_limit,
                values.flat_rate_amex_transaction,
                errors.flat_rate_amex_transaction,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "flat_rate_amex_transaction",
                      value: e.target.rawValue,
                    },
                  });
                  setBackup(prev => ({
                    ...prev,
                    flat_rate_amex_transaction: e.target.rawValue,
                  }));
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted || values?.flat_rate_amex_toggle === 'no'}
            />
          </div>
        </div>
      </div>

      <PinBasedDebit pricingModel="flat_rate" />
    </>
  );
};

export default FlatRate;
